import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmployeesComponent } from './employees.component';
import { CoreModule } from 'src/app/core/core.module';
import { EmployeesRoutingModule } from './employees-routing.module';
import { EmployeeService } from 'src/app/core/services/employee.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InviteService } from 'src/app/core/services/invite.service';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastsContainerComponent } from 'src/app/core/components/toast/toasts-container.component';
import { EmployeeProfileComponent } from './employee-profile/employee-profile.component';
import { SnakeCasePipe } from 'src/app/core/pipes/snake-case.pipe';
import { CheckboxComponent } from "src/app/core/components/checkbox/checkbox.component";

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    CoreModule,
    EmployeesRoutingModule,
    ReactiveFormsModule,
    ToastsContainerComponent,
    SnakeCasePipe,
    CheckboxComponent
],
  providers: [EmployeeService, InviteService],
  declarations: [EmployeesComponent, EmployeeProfileComponent],
  exports: [EmployeesComponent],
})
export class EmployeesModule {}
